








import { InstanceResolver } from '@/util/instanceResolver'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class SignupDefaultAttention extends Vue {
  @Prop({ required: true })
  hostName: string

  get rule(): string {
    return `${this.prefix}/rule`
  }
  get privacy(): string {
    return `${this.prefix}/privacy`
  }

  private get prefix(): string {
    return InstanceResolver.isSingle() ?
      '' :
      '/mycolor'
  }
}
